import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

// Fetch a report endpoint whenever params change. Stale responses (from an
// earlier params set) are discarded so rapid filter changes can't race.
export default function useReport(path, params, { enabled = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState('');
  const seq = useRef(0);

  const key = JSON.stringify(params);

  useEffect(() => {
    if (!enabled) return;
    const mySeq = ++seq.current;
    setLoading(true);
    setError('');
    axios.get(`/api/reports/${path}`, { params: JSON.parse(key) })
      .then(res => {
        if (seq.current !== mySeq) return;
        setData(res.data);
        setLoading(false);
      })
      .catch(err => {
        if (seq.current !== mySeq) return;
        setError(err.response?.data?.error || err.message || 'Request failed');
        setLoading(false);
      });
  }, [path, key, enabled]);

  return { data, loading, error };
}
